import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { AxiosInstance } from "../../../../axios";
// import moment from "moment";
// import Swal from "sweetalert2";
// import ReadViewSubject from "./ReadViewSubject";
// import CategorySubject from "./CategorySubject";
import Loader from "../../Loader";

export default function ReadViewPMem(props) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }

  const [formFields, setFormFields] = useState({
    fname: "",
    lname: "",
    phoneNumber: "",
    email: "",
    status: "",
    department: "",
    designation: "",
    is_eligible_class: "",
  });

  const [addJob, setAddJob] = useState([
    {
      id: 1,
      department: "",
      exp_designation: "",
    },
  ]);

  useEffect(() => {
    setIsLoading(true);
    AxiosInstance.post("api/staff/view", {
      user_id: props.userId ? props.userId : "",
    })
      .then((res) => {
        if (res.data.status === true) {
          setIsLoading(false);
          setFormFields({
            fname: res.data.data.first_name,
            lname: res.data.data.last_name,
            phoneNumber: res.data.data.mobile_no,
            email: res.data.data.email,
            status: res.data.data.status,
            is_eligible_class: res.data.data.is_eligible_class,
          });
          const addj = res.data.data.subject.map((item, index) => ({
            id: index + 1,
            department: item.department,
            exp_designation: item.exp_designation,
          }));
          // Updating the state with the modified data
          setAddJob(addj);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        return error;
      });
  }, [props.userId]);

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const UpgradeHandle = () => {
    const state = {
      // Your state properties here...
      upgrade: 1,
    };
    navigate(`/Faculties/addfaculty/${0}/${props.userId}`, { state });
  };
  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div
      className={
        props.activeTab === 4
          ? "container-fluid  global_container p-0 BathDet"
          : "container-fluid  global_container p-0 hide "
      }
      style={{ marginTop: 0, marginBottom: 0 }}
      id="ex2-content"
    >
      <div
        className={
          props.activeTab === 4
            ? "tab-pane fade show active col-md-12"
            : "tab-pane fade col-md-12 "
        }
      >
        <div className="row align-items-center mb-3">
          <div className="col-md-12 d-flex justify-content-end">
            <ul className="List-Button d-flex p-0 m-0">
              {/* Edit Button */}
              <li className="ListBtnItems d-flex align-items-center justify-content-center">
                <Link
                  to={`/Faculties/AddPanelMember/${props.userId}`}
                  className="primaryButton d-flex align-items-center justify-content-center text-center"
                  variant="primary"
                >
                  Edit Panel Member Profile
                </Link>
              </li>

              {/* Submit Button */}
              <li className="ListBtnItems ms-2 d-flex align-items-center justify-content-center">
                <Link
                  to="javascript:void(0)"
                  onClick={UpgradeHandle}
                  className="primaryButton d-flex align-items-center justify-content-center text-center"
                  variant="primary"
                >
                  Upgrade to Teaching Faculty
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <fieldset className="mt-3">
          <legend className="w-auto">Basic Details</legend>
          <div className="row mb-3">
            <div className="col-md-12">
              <div className="row">
                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">First Name</p>
                    <p className="confirm_value my-1">
                      {formFields.fname || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Last Name</p>
                    <p className="confirm_value my-1">
                      {formFields.lname || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Phone Number</p>
                    <p className="confirm_value my-1">
                      {formFields.phoneNumber || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Email ID</p>
                    <p className="confirm_value my-1">
                      {formFields.email || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Status</p>
                    <p className="confirm_value my-1">
                      {formFields.status === 4 ? "Active" : "Inactive"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Job Type</p>
                    <p className="confirm_value my-1">
                      {" "}
                      {formFields.is_eligible_class === 0
                        ? "Non Teaching"
                        : "Teaching"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        {addJob.map((el, index) => (
          <div className="col-md-12" key={index}>
            <fieldset className="mt-3">
              <legend className="w-auto">
                Job Info {addJob.length > 1 ? `- ${el.id}` : ""}
              </legend>

              <div className="row mb-3">
                <div className="col-md-12">
                  <div className="row">
                    {/*   Department */}
                    <div className="col-lg-3 col-md-6 col-12 mb-3">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0"> Department</p>
                        <p className="confirm_value my-1">
                          {" "}
                          {el.department || "-"}
                        </p>
                      </div>
                    </div>

                    {/* Designation */}
                    <div className="col-lg-3 col-md-6 col-12 mb-3">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0">Designation</p>
                        <p className="confirm_value my-1">
                          {el.exp_designation || "-"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        ))}
      </div>
    </div>
  );
}
